module.exports = __webpack_public_path__ + "img/apollo.19007faf.svg";